<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="16">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >客户管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
				<el-col :span="8" align="right">
					<el-button icon="el-icon-plus" type="primary"  size="mini" @click="popAddCustomerPanel()">添加客户</el-button>
					<el-button icon="el-icon-upload" type="primary" size="mini" @click="popUploadCustomerProductView()" >上传客户产品Excel</el-button>
					<el-button icon="el-icon-download" type="primary" size="mini" @click="downloadCustomerInfo()" >下载客户数据</el-button>
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header" :stripe="true" :height="tableHeight">
				<el-table-column prop="name" label="姓名" >
					<template slot-scope="scope">
						<el-button
							@click.native.prevent="goToCustomerView(scope.row)"
							type="text"
							size="medium">{{scope.row.name}}
						</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="phone" label="手机号">
				</el-table-column>
				<el-table-column prop="idcard" label="身份证号">
					<template slot-scope="scope">
						{{idcardChange(scope.row.idcard)}}
					</template>
				</el-table-column>
				<el-table-column prop="lastLoginTime" label="上次登录时间">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" :formatter="dateFormatter">
				</el-table-column>
				<el-table-column label="操作" >
					<!--<template slot="header" slot-scope="scope">-->
						<!--<el-input-->
							<!--size="small"-->
							<!--v-model="searchKey"-->
							<!--placeholder="输入客户姓名搜索"-->
							<!--@keyup.native.enter="topage"-->
							<!--@keyup.native.esc="searchKey='';topage(1)"-->
							<!--style="display: inline-block;"-->
						<!--&gt;-->
							<!--<i-->
								<!--v-if="searchKey!=''"-->
								<!--class="el-icon-close el-input__icon"-->
								<!--slot="suffix"-->
								<!--@click="searchKey=''"-->
								<!--style="margin-right: 10px;"-->
							<!--&gt;-->
							<!--</i>-->
						<!--</el-input>-->
					<!--</template>-->
					<template slot-scope="scope">
						<el-button
							size="mini"
							class="el-button--primary" icon="el-icon-edit" circle @click.native.prevent="popEditCustomerPanel(scope.row)"></el-button>
						<el-button
							size="mini"
							class="el-button--danger" icon="el-icon-delete" circle @click.native.prevent="deleteCustomerPanel(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align:right;line-height: 40px;padding-top: 5px;background:#fff;">
				<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">
				</el-pagination>
			</div>
		</el-main>
		<el-dialog title="添加客户" :visible.sync="showAddCustomerPanel">
			<add-customer-panel @addsuccess="addCustomerSuccess">

			</add-customer-panel>
		</el-dialog>
		<el-dialog title="修改客户信息" :visible.sync="showEditCustomerPanel">
			<edit-customer-panel :customer="editCustomer" @updatesuccess="updateCustomerSuccess"></edit-customer-panel>
		</el-dialog>
		<el-dialog title="上传客户产品信息" :visible.sync="showUploadCustomerProductPanel">
			<upload-customer-product-panel @uploadsuccess="uploadCustomerProductSuccess"></upload-customer-product-panel>
		</el-dialog>
	</el-container>
</template>
<script>
	import config from "../../../config/global.js";
	import axios from "axios"
	import AddCustomerPanel from  "./AddCustomerPanel.vue"
	import EditCustomerPanel from "./EditCustomerPanel.vue";
	import UploadCustomerProductPanel from "./UploadCustomerProductPanel.vue"

	export default {
		components: {
			AddCustomerPanel,EditCustomerPanel,UploadCustomerProductPanel
		},
		props:{

		},
		data() {
			return {
				tableData: [],
				fileLoading:false,
				searchKey:'',
				total:0,
				pageSize:200,
				currentPageIndex:1,
				tableHeight:window.innerHeight-170+"px",
				showAddCustomerPanel:false,
				showEditCustomerPanel:false,
				showUploadCustomerProductPanel:false,
				editCustomer:{}
			}
		},
		methods:{
			goToCustomerView:function (item) {
				this.$router.push({name:"customerview",query:{id:item.id}})
			},
			popAddCustomerPanel(){
				this.showAddCustomerPanel = true;
			},
			popUploadCustomerProductView:function () {
				this.showUploadCustomerProductPanel = true;
			},
			popEditCustomerPanel(item){
				var customer = JSON.parse(JSON.stringify(item));
				this.editCustomer = customer;
				this.showEditCustomerPanel = true;
			},
			deleteCustomerPanel:function (item) {
				this.$confirm('您确定要删除该客户吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					axios({
						method: 'post',
						url:config.host+"/backend/customer/delete.json?id="+item.id,
						data:{}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '客户已成功删除',
							type: 'success'
						});
						this.queryCustomers();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			queryCustomers(){
				var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
				var size = this.pageSize;
				axios({
					method: 'post',
					url:config.host+'/backend/customer/list.json',
					data:{start,size,name:this.searchKey}
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					this.tableData = response.data.items
					this.total = response.data.total
				})
					.catch((error)=>{
						console.log(error)
					})
			},
			topage(pageIndex){
				this.query((pageIndex-1)*this.pageSize,this.pageSize)
			},
			addCustomerSuccess:function () {
				this.showAddCustomerPanel = false;
				this.queryCustomers();
			},
			updateCustomerSuccess:function () {
				this.showEditCustomerPanel = false;
				this.queryCustomers();
			},
			uploadCustomerProductSuccess:function () {
				this.showUploadCustomerProductPanel = false;
				this.queryCustomers();
			},
			currentPageChangeHandler:function (val) {
				this.currentPageIndex = val;
				this.queryCustomers();
			},
			idcardChange:function(orginal){
				if(!orginal){
					return ''
				}else if(orginal.length>8){
					var result = '';
					for(var i=0;i<orginal.length;i++){
						if(i<4 || i>orginal.length-5) {
							result += orginal[i];
						}else{
							result += '*';
						}
					}
					return result;
				}else{
					return orginal
				}
			},
			dateFormatter:function (row, column,cellValue,index) {
				if(cellValue.length>10){
					return cellValue.substring(0,10);
				}else{
					return cellValue;
				}
			},
			//下载客户数据
			downloadCustomerInfo:function (){
				var url = config.host+'/backend/customer/download';
				window.open(url,"_blank");
				// if(this.fileLoading == true)
				// 	return
				// this.fileLoading = true;
				// let _this = this;
				// axios({
				// 	method: 'get',
				// 	url:config.host+'/backend/customer/download'
				// }).then((res)=>{
				// 	_this.fileLoading = false;
				// 	let fileName = "客户列表.xlsx";
				// 	fileName = decodeURIComponent(fileName);
				// 	const url = window.URL.createObjectURL(new Blob([res.data]));
				// 	const link = document.createElement("a");
				// 	link.href = url;
				// 	link.setAttribute("download", fileName); // 设置下载的文件名
				// 	document.body.appendChild(link);
				// 	link.click();
				// 	document.body.removeChild(link);
				// 	window.URL.revokeObjectURL(url);
				// }).catch((error)=>{
				// 	_this.fileLoading = false;
				// 	_this.$message.error("文件下载失败");
				// });
			}
		},
		mounted:function(){
			this.queryCustomers();
		}
	}
</script>
<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}
	.el-icon-male{
		color: #2986ff;
	}

	.el-icon-female{
		color: deeppink;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/customer/CustomerQuery.vue